module.exports = __webpack_public_path__ + "assets/img/investuotojams.3d0d7cb9.jpg";